<template>
  <ButtonGroup :color="color">
    <Btn :color="color" @click="$emit('open')" data-test-id="filter-toggle">
      <FilterIcon16 />
      {{ $t('filter.button.title') }}
      <template v-if="numberOfFilters">({{ numberOfFilters }})</template>
    </Btn>

    <Btn v-if="numberOfFilters" @click="$emit('clear')" :color="color" icon data-test-id="filter-clear">
      <CloseIcon16 />
    </Btn>
  </ButtonGroup>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import FilterIcon16 from './Icons/FilterIcon16.vue';
import CloseIcon16 from './Icons/CloseIcon16.vue';

export default defineComponent({
  name: 'FilterButton',

  emits: { clear: null, open: null },

  components: {
    FilterIcon16,
    CloseIcon16,
  },

  props: {
    numberOfFilters: {
      type: Number,
      required: true,
    },

    /**
     * Turn button blue when numberOfFilters > 0
     */
    blueWhenActive: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    color() {
      return this.numberOfFilters && this.blueWhenActive ? 'blue' : 'grey';
    },
  },
});
</script>
